import { HeadTags } from "./head-tags";
import { HeadDefaults } from "./head-defaults";
import { useServices } from "@/services-context";
import { Helmet } from "react-helmet-async";

export const DocumentElements = () => {
    return (
        <>
            <DocumentAttributes />
            <HeadTags />
            <HeadDefaults />
        </>
    );
};

const DocumentAttributes = () => {
    const services = useServices([]);

    const htmlLang = services.parameters.parameters?.language ?? 'en';

    const theme = services.customerChannel.colorScheme ?? "default";
    const template = services.customerChannel.template ?? "default";

    return (
        <Helmet>
            <html lang={htmlLang} />
            <body data-theme={theme} data-template={template} />
        </Helmet>
    );
};
